import React from "react";
import { Link } from "gatsby";
import { DropDown, DropDownList, DropDownListItem } from "./dropdown";

function PortableBuildings({ isActive }) {  
	return (
	  <DropDown className={`dropdown-menu ${isActive ? "active" : ""}`}>
		<DropDownList>
			<DropDownListItem><Link to="/portable-buildings/end-gables">End Gables</Link></DropDownListItem>
			<DropDownListItem><Link to="/portable-buildings/side-gables">Side Gables</Link></DropDownListItem>
			<DropDownListItem><Link to="/portable-buildings/porch-models">Porch Models</Link></DropDownListItem>
			<DropDownListItem><Link to="/portable-buildings/lofted-barns">Lofted Barns</Link></DropDownListItem>
			<DropDownListItem><Link to="/portable-buildings">All Portable Buildings</Link></DropDownListItem>
		</DropDownList>
	  </DropDown>
	);
}

export default PortableBuildings;